import React from 'react'
import "./popup.css"
import UpgradePlan from '../payment/UpgradePlan';
function Popup(props) {
 
  return (props.trigger) ? (
    <div className='popup'>
        <div className='innerPopup'>
            <h3 className='closebutton' onClick={() =>{props.setTrigger(false)}}>X</h3>
            <UpgradePlan />
        </div>
    </div>
  ) : "" ;
}
export default Popup